export default __webpack_public_path__ + "static/media/img-stats-graf-02.03ada5fa.jpg";